export default {
  name: 'TabText',
  props: {
    items: Object,
    currentTab: String
  },
  computed: {
    tabItems: function() {
      const { items } = this;
      return Object.keys(items).map(key => ({ ...items[key], key }));
    }
  }
};
